import hash, { type BaseOptions, type NotUndefined } from 'object-hash';

export default function hashCode(
  data: NotUndefined,
  options?: BaseOptions,
): string {
  return hash(data, options);
}
